import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../../../Resume-Upload/ResumeUpload.css";
import "./CreateClient.css";
import VybogTALLoaderAnimation from "../../../../Common/Dynamic-Animations/DynamicAnimations.js";
import Button from "../../../../Common/Button/Button";
import addIcon from "../../../../Assets/Images/addIcon.png";
import mailIcon from "../../../../Assets/Images/mail_icon.png";
import phoneIcon from "../../../../Assets/Images/phone_icon.png";
import createClientIcon from "../../../../Assets/Images/Create New Client Icon Light.svg";
import createDarkClientIcon from "../../../../Assets/Images/Create New Client Icon Dark.svg";
import accountIcon from "../../../../Assets/Images/accountIcon.png";
import clientsPageIcon from "../../../../Assets/Images/clients-header-icon.svg";
import DynamicTextField from "../../../../Common/Textfield/Textfield";
import TextInput from "../../../../Common/TextInput/TextInput";
import PhoneNumberInput from "../../../../Common/PhoneNumberInput/PhoneNumberInput";
import clientsPageDarkIcon from "../../../../Assets/Images/clients-header-darkicon.svg";
import { DynamicContext } from "../../../../Context/DynamicContext";
import { post, get, deleteRequest, put } from "../../../../helper/Api_helper";
import jobIcon from "../../../../Assets/Images/jobTypeIcon.png";
import ContentDialog from "../../../../Common/Content-Dialog/ContentDialog.js";
import NoDataFoundAnimation from "../../../../Assets/Json/nodata-found-robot-animation.json";
import ClientSearchDarkIcon from "../../../../Assets/Images/Clients Search Icon Dark.svg";
import ClientSearchLightIcon from "../../../../Assets/Images/Clients Search Icon Light.svg";
import CustomTooltip from "../../../../Common/Tooltip/Tooltip.js";
import locationViewIcon from "../../../../Assets/Images/location_icon.svg";
import {
  VYLABS_BASE_URL,
  CREATE_CLIENT,
  GET_CLIENTS_LIST,
  GET_CLIENT_DETAILS,
  GET_JOB_LIST_BY_CLIENT,
  SEARCH_CLIENTS,
  CREATE_CLIENT_TRACKING,
  UPDATE_CLIENT_INFO,
  DELETE_CLIENT_DETAILS,
  CLIENT_TRACKING,
  GET_RECRUITER_BY_ID,
  GET_JOB_DETAILS_BY_ID,
  SIMPLE_SEARCH_CANDIDATES,
  UPDATE_JOB,
  DELETE_JOB_DETAILS as DELETE_JOB,
  CREATE_CLIENT_CONTACT,
  UPDATE_CLIENT_CONTACT,
  DELETE_CLIENT_CONTACT,
  CALLBACK_REMAINDERS,
  CALLBACK_REMAINDERS_CREATE,
  CALLBACK_REMAINDERS_DELETE,
  CALLBACK_REMAINDERS_UPDATE,
} from "../../../../helper/url_helper";
import { Toast } from "../../../../Common/Toast-Snackbar/ToastSnackbar";
import SidePopup from "../../../../Common/SidePopup/SidePopup";
import ClientCard from "../../../../Common/Card/Client-Card/ClientCard";
import DynamicSkeleton from "../../../../Common/Skeleton/Skeleton";
import GlobalSearchBox from "../../../../Common/GlobalSearchBox/GlobalSearchBox";
import OptionsData from "../../../../Assets/Json/StaticOptions.json";
import { JobStatusUpdatePopup } from "../../../../Common/Card/JobsCard";
import locationIcon from "../../../../Assets/Images/location-icon_blue.svg";
import editIcon from "../../../../Assets/Images/edit-track-icon.svg";
import deleteIcon from "../../../../Assets/Images/delete-red-icon.png";
import AnimationPlayer from "../../../../Common/Animation-Player/AnimationPlayer";
import sendIconDarkAnimation from "../../../../Assets/Json/nodata-found-robot-animation.json";
import SelectInput from "../../../../Common/Select-Input/SelectInput.js";
import TextArea from "../../../../Common/TextArea/TextArea";
import { ConfirmationPopup } from "../../../../Common/PopupStyles/PopupComponent.js";
import {
  handleTriggerClear,
  handleCustomTrim,
} from "../../../../Common/Common-Function/CommonFunctions.js";
import { applyEllipsis } from "../../../../Common/Common-Function/CommonFunctions.js";
import JobsDetailsContainer from "../../../../Common/Jobs-Details-Container/JobsDetailsContainer.js";
import { candidatesCache } from "../../Jobs/RecommendCandidates.js";
import ClientDocuments from "./ClientDocuments.js";
import ClientFilters from "./ClientFilters.js";
import filterDarkIcon from "../../../../Assets/Images/filter-16-dark.svg";
import filterIcon from "../../../../Assets/Images/filter-16-light.svg";
import rightArrowIcon from "../../../../Assets/Images/arrow-right.png";
import ClientJobs from "./ClientJobs";
import ClientTracking from "./ClientTracking";
import ClientAdditionalContacts from "./ClientAdditionalContacts";
import moment from "moment";
import ClientImportXL from "./ClientImportXL.js";
import backArrowIcon from "../../../../Assets/Images/arrow-back-icon.png";
import importIcon from "../../../../Assets/Images/import-blue-Icon.svg";

function CreateClient() {
  const {
    isDarkMode,
    userDetails,
    MemberAccess,
    isHiringTeamTenant,
    setShowSpreadsheetResults,
    setUploadedResumes,
    setSpreadsheetLoading,
    formatDateWithUserTimezone,
  } = useContext(DynamicContext);
  const { StaticOptions = {} } = OptionsData || {};
  const tenantLabel = isHiringTeamTenant ? "Hiring Team" : "Client";
  const tenantLabelLower = isHiringTeamTenant ? "hiring team" : "client";
  const tenantLabelLowerPlural = isHiringTeamTenant ? "hiring team" : "clients";
  //   const { client_filter_options = {} } = staticData;
  // const { filteroptions = [] } = client_filter_options || {};
  const clientFilterContainerRef = useRef(null);
  const filteroptions = [
    {
      name: isHiringTeamTenant ? "Hiring Team Name" : "Client Name",
      id: "company_name",
    },
    {
      name: "Location",
      id: "location",
    },
    {
      name: "Contact Person",
      id: "contact_person",
    },
    {
      name: "Email",
      id: "email",
    },
    {
      name: "Priority",
      id: "clientPriority",
    },
    ...(!isHiringTeamTenant
      ? [
          {
            name: "Company Status",
            id: "clientStatus",
          },
        ]
      : []),
    {
      name: isHiringTeamTenant ? "Division" : "Client Type",
      id: "client_type",
    },
  ];
  const defaultClientFilter = filteroptions[0] || "";
  const { clientStatus = [], hiringTeamStatus = [] } = StaticOptions;
  const { clientPriority = [] } = StaticOptions;
  const activeClientStatusOptions = isHiringTeamTenant
    ? hiringTeamStatus
    : clientStatus;
  const observer = useRef();
  const clientJobsListObserver = useRef();

  const [clientList, setClientList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clientListOffset, setClientListOffset] = useState(0);
  const [viewClient, setViewClient] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [clientJobsListHasMore, setClientJobsListHasMore] = useState(true);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [activeTab, setActiveTab] = useState("Jobs");
  const [isCreatingClient, setIsCreatingClient] = useState(false);
  const [clientJobsList, setClientJobsList] = useState([]);
  const [clientJobsListOffset, setClientJobsListOffset] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterKey, setFilterKey] = useState("");
  const [secondaryValue, setSecondaryValue] = useState("");
  const [isEditingClient, setIsEditingClient] = useState(false);
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [clearTriggered, setClearTriggered] = useState(false);
  const [changedClient, setChangedClient] = useState({});
  const [isFetchCompleted, setIsFetchCompleted] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [hasClientProfiles, setHasClientProfiles] = useState(false);
  const [isClientFilterOpen, setIsClientFilterOpen] = useState(false);
  const [activeClientFilterType, setActiveClientFilterType] = useState("");
  const [activeClientFilterUserId, setActiveClientFilterUserId] = useState("");
  const [createdByUserId, setCreatedByUserId] = useState("");
  const [isTrackedByMeActive, setIsTrackedByMeActive] = useState(false);
  const [clientCreatedUserName, setClientCreatedUserName] =
    useState("Loading...");
  const [isCreatedByMeActive, setIsCreatedByMeActive] = useState(false);
  const [isClientDeleteDialogOpen, setIsClientDeleteDialogOpen] =
    useState(false);
  const [getClientID, setGetClientID] = useState(null);
  const [prevFilterKey, setPrevFilterKey] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const [jobsSideContainerOpen, setJobsSideContainerOpen] = useState(false);
  const [selectedJobDetails, setSelectedJobDetails] = useState(null);
  const [jobDetailsActiveTab, setJobDetailsActiveTab] = useState("Job Details");
  const [isEditingJob, setIsEditingJob] = useState(false);
  const [originalJobData, setOriginalJobData] = useState(null);
  const [editedJobData, setEditedJobData] = useState(null);
  const [jobDetailsValidation, setJobDetailsValidation] = useState(null);
  const [openJobDeleteDialog, setOpenJobDeleteDialog] = useState(false);
  const [showClientContactPopup, setShowClientContactPopup] = useState(false);
  const [showEditContactPopup, setShowEditContactPopup] = useState(false);
  const [showDeleteContactPopup, setShowDeleteContactPopup] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [assignedCount, setAssignedCount] = useState(0);
  const [isFetchingRecommendedCandidates, setIsFetchingRecommendedCandidates] =
    useState(false);
  const [selectedContactId, setSelectedContactId] = useState("");
  const [contactOptions, setContactOptions] = useState([]);
  const [isViewingContact, setIsViewingContact] = useState(false);
  const [activeClientFilterFromDate, setActiveClientFilterFromDate] =
    useState("");
  const [activeClientFilterEndDate, setActiveClientFilterEndDate] =
    useState("");
  const [trackingRefreshKey, setTrackingRefreshKey] = useState(0);
  const [showReminderDialog, setShowReminderDialog] = useState(false);
  const [callbackRemainderRes, setCallbackRemainderRes] = useState([]);
  const [isImportOpen, setIsImportOpen] = useState(false);
  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!selectedClient?.user_id) {
        setClientCreatedUserName("N/A");
        return;
      }
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${GET_RECRUITER_BY_ID}?id=${selectedClient.user_id}`,
        );
        if (response?.user) {
          setClientCreatedUserName(
            `${response.user.first_name} ${response.user.last_name}`.trim(),
          );
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setClientCreatedUserName("Unknown");
      }
    };

    if (viewClient && selectedClient?.user_id) {
      fetchUserDetails();
    } else if (!viewClient) {
      setClientCreatedUserName("Loading...");
    }
  }, [selectedClient?.user_id, viewClient]);

  const formik = useFormik({
    initialValues: {
      email: "",
      clientName: "",
      companyType: "",
      contactPerson: "",
      contactDesignation: "",
      mobile: "",
      secondaryMobile: "",
      country: "",
      state: "",
      city: "",
      address1: "",
      address2: "",
      clientStatus: "",
      clientPriority: "",
      zipCode: "",
      remarks: "",
      clientType: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format.")
        .trim()
        .required("Email is required."),
      clientName: Yup.string()
        .trim()
        .required(
          isHiringTeamTenant
            ? "Hiring Team Name is required."
            : "Client Name is required.",
        ),
      contactPerson: Yup.string()
        .trim()
        .required("Contact Person is required."),
      contactDesignation: Yup.string()
        .trim()
        .required("Contact Designation is required."),
      mobile: Yup.string()
        .trim()
        .required("Mobile number is required.")
        .matches(/^\+?[0-9]+$/, "Invalid phone number format."),
      secondaryMobile: Yup.string()
        .matches(/^[0-9]+$/, "Only digits are allowed.")
        .notRequired(),
      country: Yup.string().trim(),
      state: Yup.string().trim(),
      city: Yup.string().trim(),
      address1: Yup.string().trim(),
      zipCode: Yup.string()
        .trim()
        .matches(/^[0-9]+$/, "Only digits are allowed for Zipcode."),
      remarks: Yup.string().trim().required("Remarks is required."),
      clientPriority: Yup.string().trim().required("Priority is required."),
      clientStatus: Yup.string()
        .trim()
        .required(
          isHiringTeamTenant ? "Activity is required" : "Status is required.",
        ),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    validateOnSubmit: true,
  });
  const contactFormik = useFormik({
    initialValues: {
      contactName: "",
      contactEmail: "",
      contactPhoneNumber: "",
      contactDesignation: "",
      contactLocation: "",
    },
    validationSchema: Yup.object({
      contactName: Yup.string()
        .trim()
        .required("Contact Person Name is required"),
      contactEmail: Yup.string()
        .email("Invalid email address")
        .trim()
        .required("Email is required"),
      contactPhoneNumber: Yup.string()
        .trim()
        .required("Phone number is required")
        .matches(/^(\+)?[0-9\s\-\(\)]+$/, "Invalid phone number"),
      contactDesignation: Yup.string()
        .trim()
        .required("Contact Designation is required"),
      contactLocation: Yup.string().trim().required("Location is required"),
    }),
    onSubmit: (values) => {
      if (isEditingContact) {
        handleUpdateClientContactDetails(values);
      } else {
        handleCreateClientContactDetails(values);
      }
    },
  });
  const handleContactPhoneInputChange = React.useCallback(
    (phone) => {
      const normalizedPhone = phone?.startsWith("+") ? phone : `+${phone}`;
      contactFormik.setFieldValue("contactPhoneNumber", normalizedPhone);
      contactFormik.setFieldTouched("contactPhoneNumber", true, false);
      contactFormik.validateField("contactPhoneNumber");
    },
    [contactFormik],
  );

  const handleOpenAddContactPopup = () => {
    setIsEditingContact(false);
    setSelectedContact(null);
    contactFormik.resetForm();
    setShowClientContactPopup(true);
  };

  const handleOpenEditContactPopup = (contact) => {
    setIsEditingContact(true);
    setSelectedContact(contact);
    contactFormik.setValues({
      contactName: contact.name || "",
      contactEmail: contact.email || "",
      contactPhoneNumber: contact.phone || "",
      contactDesignation: contact.designation || "",
      contactLocation: contact.location || "",
    });
    setShowEditContactPopup(true);
  };

  const handleOpenViewContactPopup = (contact) => {
    setIsViewingContact(true);
    setSelectedContact(contact);
    contactFormik.setValues({
      contactName: contact.name || "",
      contactEmail: contact.email || "",
      contactPhoneNumber: contact.phone || "",
      contactDesignation: contact.designation || "",
      contactLocation: contact.location || "",
    });
    setShowEditContactPopup(true);
  };

  const handleOpenDeleteContactPopup = (contact) => {
    setSelectedContact(contact);
    setShowDeleteContactPopup(true);
  };

  const handleCloseContactPopup = () => {
    setShowClientContactPopup(false);
    setShowEditContactPopup(false);
    contactFormik.resetForm();
    setSelectedContact(null);
    setIsEditingContact(false);
    setIsViewingContact(false);
  };

  const handleCreateClientContactDetails = async (values) => {
    try {
      const errors = await contactFormik.validateForm();
      if (Object.keys(errors).length > 0) {
        contactFormik.setTouched({
          contactName: true,
          contactEmail: true,
          contactPhoneNumber: true,
          contactDesignation: true,
          contactLocation: true,
        });
        Toast("error", "Please fill all required fields correctly");
        return;
      }

      await post(VYLABS_BASE_URL, CREATE_CLIENT_CONTACT, {
        email: values.contactEmail.trim(),
        client_id: selectedClient?.id,
        name: values.contactName.trim(),
        phone: values.contactPhoneNumber.startsWith("+")
          ? values.contactPhoneNumber
          : `+${values.contactPhoneNumber}`,
        designation: values.contactDesignation.trim(),
        location: values.contactLocation?.trim() || "",
      });
      Toast("success", "Contact added successfully");
      handleCloseContactPopup();
      if (selectedClient?.id) {
        await fetchClientDetails();
      }
    } catch (error) {
      console.error("Create Client Contact Details error", error);
      Toast(
        "error",
        error.response?.data?.message ||
          "Failed to add contact. Please try again.",
      );
    }
  };

  const handleUpdateClientContactDetails = async (values) => {
    try {
      const errors = await contactFormik.validateForm();
      if (Object.keys(errors).length > 0) {
        contactFormik.setTouched({
          contactName: true,
          contactEmail: true,
          contactPhoneNumber: true,
          contactDesignation: true,
          contactLocation: true,
        });
        Toast("error", "Please fill all required fields correctly");
        return;
      }

      await post(VYLABS_BASE_URL, UPDATE_CLIENT_CONTACT, {
        id: selectedContact?.id,
        email: values.contactEmail.trim(),
        name: values.contactName.trim(),
        phone: values.contactPhoneNumber.startsWith("+")
          ? values.contactPhoneNumber
          : `+${values.contactPhoneNumber}`,
        designation: values.contactDesignation.trim(),
        location: values.contactLocation?.trim(),
      });
      Toast("success", "Contact updated successfully");
      handleCloseContactPopup();
      if (selectedClient?.id) {
        await fetchClientDetails();
      }
    } catch (error) {
      console.error("Update Client Contact Details error", error);
      Toast(
        "error",
        error.response?.data?.message ||
          "Failed to update contact. Please try again.",
      );
    }
  };

  const handleDeleteClientContactDetails = async () => {
    if (!selectedContact?.id) {
      Toast("error", "No contact selected for deletion");
      return;
    }

    try {
      await deleteRequest(VYLABS_BASE_URL, DELETE_CLIENT_CONTACT, {
        id: selectedContact.id,
      });
      Toast("success", "Contact deleted successfully");
      setShowDeleteContactPopup(false);
      setSelectedContact(null);

      if (selectedClient?.id) {
        await fetchClientDetails();
      }
    } catch (error) {
      console.error("Delete Client Contact Details error", error);
      Toast(
        "error",
        error.response?.data?.message ||
          "Failed to delete contact. Please try again.",
      );
    }
  };
  const fetchClientDetails = useCallback(async () => {
    if (selectedClient?.id) {
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${GET_CLIENT_DETAILS}/?id=${selectedClient.id}`,
        );
        setSelectedClient(response.client);
        setChangedClient(response.client);
      } catch (err) {
        console.error("Error refreshing client details:", err);
      }
    }
  }, [selectedClient?.id]);
  const jobEditFormik = useFormik({
    initialValues: {
      title: "",
      client_id: "",
      yearsOfExperience: "",
      educationLevel: "",
      company: "",
      jobLocation: "",
      jobType: "",
      skills: [],
      jobDescription: "",
      jobRole: "",
      salary_min: "",
      salary_max: "",
      tags: [],
      languageProficiency: "",
      openings: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Job Title is required"),
      jobRole: Yup.string().required("Job Role is required"),
      jobType: Yup.string().required("Job Type is required"),
      jobLocation: Yup.string().required("Job Location is required"),
      yearsOfExperience: Yup.number()
        .required("Experience is required")
        .integer("Experience must be an integer")
        .max(99, "Please enter a two digit number")
        .typeError("Experience must be a number"),
      salary_min: Yup.number(),
      salary_max: Yup.number(),
      jobDescription: Yup.string().nullable(),
      skills: Yup.mixed()
        .test(
          "is-array-or-string",
          "Skills must be an array or string",
          function (value) {
            return Array.isArray(value) || typeof value === "string";
          },
        )
        .required("Skills are required"),
      tags: Yup.array().nullable(),
      openings: Yup.number()
        .required("Number of openings is required")
        .integer("Number of openings must be an integer")
        .min(1, "Number of openings must be at least 1")
        .typeError("Number of openings must be a number"),
    }),
  });

  const sideDialogformik = useFormik({
    initialValues: {
      linkedIn: false,
      atolla: false,
    },
  });

  useEffect(() => {
    if (selectedClient) {
      const initialValues = {
        email: selectedClient?.email || "",
        clientName: selectedClient?.name || "",
        contactPerson: selectedClient?.contact_person || "",
        contactDesignation: selectedClient?.contact_designation || "",
        mobile: selectedClient?.phone || "",
        country: selectedClient?.country || "",
        state: selectedClient?.state || "",
        city: selectedClient?.city || "",
        address1: selectedClient?.address || "",
        address2: selectedClient?.address_2 || "",
        zipCode: selectedClient?.zip_code || "",
        remarks: selectedClient?.remarks || "",
        clientStatus: selectedClient?.status || "",
        clientPriority: selectedClient?.priority || "",
        clientType: selectedClient?.client_type || "",
      };
      formik.setValues(initialValues);
      formik.setTouched({});
    }
  }, [selectedClient]);

  useEffect(() => {
    if (activeTab === "Jobs") {
      setShowLoader(true);
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 700);
      return () => clearTimeout(timer);
    }
  }, [activeTab]);

  const editFormik = useFormik({
    initialValues: {
      editRemarks: "",
      editClientStatus: "",
      editClientPriority: "",
      editContactId: "",
    },
    onSubmit: async (values, { resetForm }) => {
      const trimmedValues = handleCustomTrim(values);
      if (
        trimmedValues.editClientStatus &&
        trimmedValues.editClientPriority &&
        trimmedValues.editRemarks
      ) {
        try {
          const payload = {
            id: selectedClient.id,
            priority: trimmedValues.editClientPriority,
            status: trimmedValues.editClientStatus,
            remarks: trimmedValues.editRemarks,
          };
          const currentContactId =
            selectedContactId || trimmedValues.editContactId;
          if (currentContactId) {
            payload.ContactID = currentContactId;
          }

          const createTrackingHistory = await post(
            VYLABS_BASE_URL,
            CREATE_CLIENT_TRACKING,
            payload,
          );
          if (createTrackingHistory?.client_id) {
            setGetClientID(createTrackingHistory.client_id);
          }
          setTrackingRefreshKey((prev) => prev + 1);
          resetForm();
          Toast("success", "Tracking history added successfully");
        } catch (error) {
          console.error("Error adding tracking history:", error);
          Toast("error", "Failed to add tracking history");
        }
      }
    },
  });

  const reminderFormik = useFormik({
    initialValues: {
      callbackAt: "",
      callbackTime: "",
      callbackOffset: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        let payload = {
          callbackReminderOffset: values?.callbackOffset,
          callbackReminderUserID: userDetails?.id,
          date: moment(values?.callbackAt).format("YYYY-MM-DD"),
          entityID: selectedClient?.id,
          entityType: "client",
          time: values?.callbackTime,
          timezone: userDetails?.timezone,
        };
        await post(VYLABS_BASE_URL, CALLBACK_REMAINDERS_CREATE, payload);
        Toast("success", "Remainder created successfully");
        fetchCallbackReminders();
        setShowReminderDialog(false);
        resetForm();
        setTrackingRefreshKey((prev) => prev + 1);
      } catch (error) {
        console.error("Error setting reminder:", error);
        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to set reminder";
        Toast("error", backendMessage);
      }
    },
  });

  const editRemainderFormik = useFormik({
    initialValues: {
      callbackAt: "",
      callbackTime: "",
      callbackOffset: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        let payload = {
          callbackReminderOffset: values?.callbackOffset,
          callbackReminderUserID: userDetails?.id,
          date: moment(values?.callbackAt).format("YYYY-MM-DD"),
          entityID: selectedClient?.id,
          entityType: "client",
          time: values?.callbackTime,
          timezone: userDetails?.timezone,
        };
        await put(VYLABS_BASE_URL, CALLBACK_REMAINDERS_UPDATE, payload);
        Toast("success", "Remainder updated successfully");
        fetchCallbackReminders();
        setShowReminderDialog(false);
        resetForm();
        setTrackingRefreshKey((prev) => prev + 1);
      } catch (error) {
        console.error("Error setting reminder:", error);
        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to set reminder";
        Toast("error", backendMessage);
      }
    },
  });

  const fetchCallbackReminders = async () => {
    try {
      const res = await get(
        VYLABS_BASE_URL,
        `${CALLBACK_REMAINDERS}?entityType=client&entityID=${selectedClient?.id}`,
      );
      if (res?.callbackReminder) {
        setCallbackRemainderRes(res.callbackReminder);
      }
    } catch (error) {
      console.error("error in fetchCallbackReminders", error);
    }
  };

  const isEditReminderMode = Boolean(callbackRemainderRes?.callbackAt);

  const handleOpenReminderDialog = () => {
    if (isEditReminderMode) {
      const callbackDateTime = new Date(callbackRemainderRes.callbackAt);
      editRemainderFormik.setValues({
        callbackAt: callbackDateTime,
        callbackTime: callbackDateTime,
        callbackOffset: callbackRemainderRes?.callbackReminderOffset || "",
      });
    } else {
      reminderFormik.resetForm();
    }
    setShowReminderDialog(true);
  };

  const handleCloseReminderDialog = () => {
    setShowReminderDialog(false);
    if (isEditReminderMode) {
      editRemainderFormik.resetForm();
    } else {
      reminderFormik.resetForm();
    }
  };

  const handleSetReminderSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (isEditReminderMode) {
      editRemainderFormik.handleSubmit(e);
    } else {
      reminderFormik.handleSubmit(e);
    }
  };

  const handleDeleteCallbackRemainder = async () => {
    try {
      await deleteRequest(VYLABS_BASE_URL, CALLBACK_REMAINDERS_DELETE, {
        entityID: selectedClient?.id,
        entityType: "client",
      });
      Toast("success", "Remainder deleted successfully.");
      fetchCallbackReminders();
      handleCloseReminderDialog();
    } catch (error) {
      console.error("error in handleDeleteCallbackReminder", error);
      Toast("error", error?.response?.data);
    }
  };

  const fetchAllClientsList = useCallback(
    async (
      customOffset = 0,
      filterType = activeClientFilterType,
      filterUserId = activeClientFilterUserId,
      fromDateFilter = activeClientFilterFromDate,
      endDateFilter = activeClientFilterEndDate,
    ) => {
      try {
        if (customOffset === 0) {
          setIsInitialLoading(true);
        } else {
          setIsLoadingMore(true);
        }
        let url = `${GET_CLIENTS_LIST}?offset=${customOffset}&limit=30`;

        if (filterType) {
          url += `&filter_by=${filterType}`;
        }
        if (filterUserId) {
          url += `&user_id=${filterUserId}`;
        }
        if (fromDateFilter) {
          url += `&fromDate=${fromDateFilter}`;
        }
        if (endDateFilter) {
          url += `&endDate=${endDateFilter}`;
        }

        const response = await get(VYLABS_BASE_URL, url);

        const { clients = [] } = response;
        const fetchedClients = Array.isArray(clients)
          ? clients.filter((c) => c?.id)
          : [];
        const isUnfilteredClientList =
          !filterType && !filterUserId && !fromDateFilter && !endDateFilter;

        if (fetchedClients.length > 0) {
          setHasClientProfiles(true);
        } else if (customOffset === 0 && isUnfilteredClientList) {
          setHasClientProfiles(false);
        }

        setClientList((prev) => {
          if (customOffset === 0) {
            return fetchedClients;
          } else {
            const existingClients = new Map();
            (prev || []).forEach((client) => {
              if (client?.id) existingClients.set(client.id, client);
            });
            fetchedClients.forEach((client) => {
              if (client?.id) existingClients.set(client.id, client);
            });
            return Array.from(existingClients.values());
          }
        });

        setHasMore(clients.length === 30);
      } catch (err) {
        console.error("fetchAllClientsList error", err);
        setClientList((prev) => prev || []);
      } finally {
        setIsInitialLoading(false);
        setIsLoadingMore(false);
        setIsFetchCompleted(true);
      }
    },
    [
      activeClientFilterType,
      activeClientFilterUserId,
      activeClientFilterFromDate,
      activeClientFilterEndDate,
    ],
  );

  const getClientDetails = async (clientId) => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_CLIENT_DETAILS}/?id=${clientId}`,
      );
      setSelectedClient(response.client);
      setChangedClient(response.client);
      setViewClient(true);
    } catch (err) {
      console.error("Client Details error", err);
    }
  };
  useEffect(() => {
    setClientListOffset(0);
    fetchAllClientsList(
      0,
      activeClientFilterType,
      activeClientFilterUserId,
      activeClientFilterFromDate,
      activeClientFilterEndDate,
    );
  }, [
    activeClientFilterType,
    activeClientFilterUserId,
    activeClientFilterFromDate,
    activeClientFilterEndDate,
    fetchAllClientsList,
  ]);
  useEffect(() => {
    if (clientListOffset > 0) {
      fetchAllClientsList(
        clientListOffset,
        activeClientFilterType,
        activeClientFilterUserId,
      );
    }
  }, [clientListOffset, fetchAllClientsList]);

  const handleCreateClient = async () => {
    if (isCreatingClient) return;

    try {
      setIsCreatingClient(true);
      const errors = await formik.validateForm();
      if (Object.keys(errors).length > 0) {
        Object.keys(errors).forEach((key) => {
          formik.setFieldTouched(key, true, false);
        });
        Toast("error", "Please fill all required fields correctly");
        return;
      }

      const payload = {
        address: formik.values.address1.trim(),
        address_2: formik.values.address2.trim(),
        city: formik.values.city.trim(),
        contactDesignation: formik.values.contactDesignation.trim(),
        contactPerson: formik.values.contactPerson.trim(),
        country: formik.values.country.trim(),
        email: formik.values.email.trim(),
        name: formik.values.clientName.trim(),
        phone: formik.values.mobile
          ? formik.values.mobile.startsWith("+")
            ? formik.values.mobile
            : `+${formik.values.mobile}`
          : "",
        priority: formik.values.clientPriority,
        remarks: formik.values.remarks.trim(),
        state: formik.values.state.trim(),
        status: formik.values.clientStatus,
        zipCode: formik.values.zipCode.trim(),
        clientType: formik.values.clientType.trim(),
      };

      await post(VYLABS_BASE_URL, CREATE_CLIENT, payload);

      Toast("success", `${tenantLabel} Created Successfully`);
      setIsModalOpen(false);
      formik.resetForm();
      // setClientList([]);
      setClientListOffset(0);
      await fetchAllClientsList(
        0,
        activeClientFilterType,
        activeClientFilterUserId,
      );
    } catch (error) {
      console.error("Create Client response error:", error);
      Toast("error", error.response?.data);
    } finally {
      setIsCreatingClient(false);
    }
  };

  const lastElement = useCallback(
    (node) => {
      if (!hasMore) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasMore && !isLoadingMore) {
            setIsLoadingMore(true);
            setClientListOffset((prev) => prev + 30);
          }
        },
        {
          root: null,
          rootMargin: "20px",
          threshold: 0.1,
        },
      );

      if (node) observer.current.observe(node);
    },
    [hasMore],
  );
  useEffect(() => {
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);
  const jobsListLastElement = useCallback(
    (node) => {
      if (!clientJobsListHasMore) return;

      if (clientJobsListObserver.current)
        clientJobsListObserver.current.disconnect();

      clientJobsListObserver.current = new IntersectionObserver(
        (entries) => {
          if (
            entries[0].isIntersecting &&
            clientJobsListHasMore &&
            !isLoadingMore
          ) {
            setIsLoadingMore(true);
            setClientJobsListOffset((prev) => prev + 30);
          }
        },
        {
          root: null,
          rootMargin: "20px",
          threshold: 0.1,
        },
      );

      if (node) clientJobsListObserver.current.observe(node);
    },
    [clientJobsListHasMore],
  );
  useEffect(() => {
    return () => {
      if (clientJobsListObserver.current) {
        clientJobsListObserver.current.disconnect();
      }
    };
  }, []);
  const handlePhoneInputChange = React.useCallback(
    (phone) => {
      const normalizedPhone = phone?.startsWith("+") ? phone : `+${phone}`;
      formik.setFieldValue("mobile", normalizedPhone);
      formik.setFieldTouched("mobile", true, false);
      formik.validateField("mobile");
    },
    [formik],
  );
  const handleOpenInviteModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseInviteModal = () => {
    setIsModalOpen(false);
    formik.resetForm();
    setSelectedClient(null);
    setIsEditingClient(false);
  };
  const handleCloseClientDetails = () => {
    setViewClient(false);
    setSelectedClient(null);
    setActiveTab("Jobs");
    setIsEditingClient(false);
    formik.resetForm();
    setSelectedContactId("");
    editFormik.resetForm();
  };

  const handleBackToClientsList = async () => {
    setSearchQuery("");
    setFilterKey(defaultClientFilter);
    setPrevFilterKey(defaultClientFilter);
    setSecondaryValue("");
    setHasSearched(false);
    setIsClientFilterOpen(false);
    setActiveClientFilterType("");
    setActiveClientFilterUserId("");
    setActiveClientFilterFromDate("");
    setActiveClientFilterEndDate("");
    setCreatedByUserId("");
    setIsTrackedByMeActive(false);
    setIsCreatedByMeActive(false);
    setClientListOffset(0);
    setClientList([]);
    setSearchResetKey((prev) => prev + 1);
    handleCloseClientDetails();
    await fetchAllClientsList(0, "", "", "", "");
  };
  useEffect(() => {
    if (selectedClient?.contacts && selectedClient.contacts.length > 0) {
      const options = selectedClient.contacts.map((contact) => ({
        value: contact.id,
        label: `${contact.name} (${contact.designation || "No designation"})${contact.email ? ` - ${contact.email}` : ""}`,
        contact: contact,
      }));
      setContactOptions(options);
    } else {
      setContactOptions([]);
    }
  }, [selectedClient?.contacts]);

  const handleDeleteClient = async () => {
    try {
      await deleteRequest(VYLABS_BASE_URL, DELETE_CLIENT_DETAILS, {
        id: selectedClient.id,
      });
      Toast("success", `${tenantLabel} deleted successfully`);
      setIsClientDeleteDialogOpen(false);
      setViewClient(false);
      setSelectedClient(null);
      setIsEditingClient(false);
      await fetchAllClientsList(
        0,
        activeClientFilterType,
        activeClientFilterUserId,
      );
    } catch (error) {
      console.error("Error deleting client:", error);
    }
  };

  const fetchClientJobs = async (customOffset = clientJobsListOffset) => {
    try {
      if (customOffset === 0) {
        setIsInitialLoading(true);
      } else {
        setIsLoadingMore(true);
      }
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_LIST_BY_CLIENT}?client_id=${selectedClient.id}&offset=${customOffset}&limit=30`,
      );
      const jobs = response?.jobs ?? [];
      const fetchedJobs = Array.isArray(jobs)
        ? jobs.filter((job) => job?.id)
        : [];

      setClientJobsList((prev) => {
        if (customOffset === 0) {
          return fetchedJobs;
        } else {
          const merged = new Map();
          (prev || []).forEach((job) => {
            if (job?.id) merged.set(job.id, job);
          });
          fetchedJobs.forEach((job) => {
            if (job?.id) merged.set(job.id, job);
          });
          return Array.from(merged.values());
        }
      });

      setClientJobsListHasMore(jobs.length === 30);
    } catch (err) {
      console.error("fetchClientJobs error:", err);
      setClientJobsList((prev) => prev || []);
    } finally {
      setIsInitialLoading(false);
      setIsLoadingMore(false);
    }
  };

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
    if (e.target.value.length === 0) {
      fetchAllClientsList();
      setHasSearched(false);
    }
  };

  const onFilterClick = (option) => {
    if (!prevFilterKey || prevFilterKey.id !== option.id) {
      if (option.id !== "clientPriority" && option.id !== "clientStatus") {
        setSecondaryValue("");
      }
    }
    setFilterKey(option);
    setPrevFilterKey(option);
    if (option.secondaryValue) {
      setSecondaryValue(option.secondaryValue);
    }
  };

  const handleClientSearch = async () => {
    const isSearchEmpty = !searchQuery?.trim();
    const isSecondaryEmpty = !secondaryValue?.trim();
    const activeFilterKey = filterKey?.id ? filterKey : defaultClientFilter;
    if (isSearchEmpty && isSecondaryEmpty) {
      Toast("error", "Please enter a search query");
      return;
    }
    if (!activeFilterKey || !activeFilterKey.id) {
      Toast("error", "Please select a search filter.");
      return;
    }

    if (
      activeClientFilterType ||
      activeClientFilterUserId ||
      isTrackedByMeActive ||
      isCreatedByMeActive
    ) {
      setActiveClientFilterType("");
      setActiveClientFilterUserId("");
      setIsTrackedByMeActive(false);
      setIsCreatedByMeActive(false);
      setCreatedByUserId("");
      setIsClientFilterOpen(false);
    }
    try {
      setIsInitialLoading(true);
      setClientListOffset(0);
      setClientList([]);
      setHasSearched(true);

      let searchUrl = `${SEARCH_CLIENTS}?`;
      if (searchQuery?.trim()) {
        if (activeFilterKey.id === "client_type") {
          searchUrl += `client_type=${searchQuery}`;
        } else {
          searchUrl += `${activeFilterKey.id}=${searchQuery}`;
        }
      }
      if (secondaryValue) {
        if (searchQuery?.trim()) {
          searchUrl += "&";
        }
        if (activeFilterKey.name === "Company Status") {
          searchUrl += `status=${secondaryValue}`;
        } else if (
          activeFilterKey.name === "Client Type" ||
          activeFilterKey.id === "client_type"
        ) {
          searchUrl += `client_type=${secondaryValue}`;
        } else {
          searchUrl += `${activeFilterKey.name.toLowerCase()}=${secondaryValue}`;
        }
      }

      const response = await get(VYLABS_BASE_URL, searchUrl);
      const { clients = [] } = response;
      let searchResults = Array.isArray(clients)
        ? clients.filter((client) => client?.name)
        : [];
      const isPriorityFilter = activeFilterKey.id === "clientPriority";
      const isStatusFilter = activeFilterKey.id === "clientStatus";
      const isClientTypeFilter = activeFilterKey.id === "client_type";
      const hasSearchInput = searchQuery?.trim().length > 0;

      if (
        (isPriorityFilter || isStatusFilter || isClientTypeFilter) &&
        hasSearchInput &&
        secondaryValue
      ) {
        const inputLower = searchQuery.trim().toLowerCase();
        const matchesInput = (client) => {
          return (
            (client.name && client.name.toLowerCase().includes(inputLower)) ||
            (client.email && client.email.toLowerCase().includes(inputLower)) ||
            (client.contact_person &&
              client.contact_person.toLowerCase().includes(inputLower))
          );
        };

        if (isPriorityFilter) {
          searchResults = searchResults.filter(
            (client) =>
              client.priority &&
              client.priority.toLowerCase() === secondaryValue.toLowerCase() &&
              matchesInput(client),
          );
        } else if (isStatusFilter) {
          searchResults = searchResults.filter(
            (client) =>
              client.status &&
              client.status.toLowerCase() === secondaryValue.toLowerCase() &&
              matchesInput(client),
          );
        } else if (isClientTypeFilter) {
          searchResults = searchResults.filter(
            (client) =>
              client.client_type &&
              client.client_type.toLowerCase() ===
                secondaryValue.toLowerCase() &&
              matchesInput(client),
          );
        }
      }

      setClientList(searchResults);
      setHasMore(searchResults.length === 30);
    } catch (error) {
      console.error("Search failed with error:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response,
        status: error.response?.status,
      });
      setClientList([]);
    } finally {
      setIsInitialLoading(false);
    }
  };
  const handleEditClient = async () => {
    setIsEditingClient(true);
  };
  const handleCancelEditClient = () => {
    setIsEditingClient(false);
    if (selectedClient) {
      const initialValues = {
        email: selectedClient?.email || "",
        clientName: selectedClient?.name || "",
        contactPerson: selectedClient?.contact_person || "",
        contactDesignation: selectedClient?.contact_designation || "",
        mobile: selectedClient?.phone || "",
        country: selectedClient?.country || "",
        state: selectedClient?.state || "",
        city: selectedClient?.city || "",
        address1: selectedClient?.address || "",
        address2: selectedClient?.address2 || "",
        zipCode: selectedClient?.zip_code || "",
        remarks: selectedClient?.remarks || "",
        clientStatus: selectedClient?.status || "",
        clientPriority: selectedClient?.priority || "",
        clientType: selectedClient?.client_type || "",
      };
      formik.setValues(initialValues);
      formik.setTouched({});
      formik.setErrors({});
    }
  };
  const fetchRecommendedCandidates = useCallback(async (jobId) => {
    try {
      setIsFetchingRecommendedCandidates(true);
      const jobRes = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_DETAILS_BY_ID}?id=${jobId}`,
      );
      const job = jobRes?.job;

      if (!job) {
        console.error("Failed to fetch job details for recommendations");
        candidatesCache.set(jobId, []);
        setIsFetchingRecommendedCandidates(false);
        return [];
      }
      let skillsArray = [];
      if (Array.isArray(job.skills)) {
        skillsArray = job.skills;
      } else if (typeof job.skills === "string") {
        skillsArray = job.skills
          .split(",")
          .map((skill) => skill.trim())
          .filter((skill) => skill !== "");
      }

      const payload = {
        limit: 20,
        job_role: job.job_role || "",
        description: job.description || "",
        location: job.location || "",
        skills: skillsArray,
        job_id: jobId,
        rerank: true,
      };
      Object.keys(payload).forEach((key) => {
        if (
          payload[key] === "" ||
          payload[key] === null ||
          payload[key] === undefined ||
          (Array.isArray(payload[key]) && payload[key].length === 0)
        ) {
          delete payload[key];
        }
      });

      const response = await post(
        VYLABS_BASE_URL,
        SIMPLE_SEARCH_CANDIDATES,
        payload,
      );

      if (
        !response ||
        !response.candidates ||
        response.candidates.length === 0
      ) {
        candidatesCache.set(jobId, []);
        setIsFetchingRecommendedCandidates(false);
        return [];
      }

      const detailedCandidates = response.candidates.map((candidate) => ({
        ...candidate,
        parsed_resume:
          typeof candidate.parsed_resume === "string"
            ? JSON.parse(candidate.parsed_resume || "{}")
            : candidate.parsed_resume || {},
        isFileBased: false,
      }));

      candidatesCache.set(jobId, detailedCandidates);
      setIsFetchingRecommendedCandidates(false);
      return detailedCandidates;
    } catch (err) {
      console.error("Error fetching recommended candidates:", err);
      setIsFetchingRecommendedCandidates(false);
      candidatesCache.set(jobId, []);
      return [];
    }
  }, []);

  const handleOpenJobDetailsContainer = async (job, index, tab) => {
    if (!job) return;
    setJobsSideContainerOpen(true);
    setJobDetailsActiveTab(tab);
    try {
      const jobRes = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_DETAILS_BY_ID}?id=${job.id}`,
      );
      let detailedJob = jobRes?.job || job;
      if (detailedJob?.client_id && !detailedJob?.client?.contact_person) {
        try {
          const clientRes = await get(
            VYLABS_BASE_URL,
            `${GET_CLIENT_DETAILS}/?id=${detailedJob.client_id}`,
          );
          if (clientRes?.client) {
            detailedJob.client = clientRes.client;
          }
        } catch (err) {
          console.warn("Could not fetch client details:", err);
        }
      }
      setSelectedJobDetails({ ...detailedJob, index });
      await fetchRecommendedCandidates(job.id);
    } catch (err) {
      console.error("Error fetching job details:", err);
      setSelectedJobDetails({ ...job, index });
      await fetchRecommendedCandidates(job.id);
    }
  };

  const handleCloseJobDetailsContainer = () => {
    setJobsSideContainerOpen(false);
    setSelectedJobDetails(null);
    setJobDetailsActiveTab("Job Details");
    if (selectedJobDetails?.id) {
      candidatesCache.delete(selectedJobDetails.id);
    }
    resetJobEdit();
  };

  const handleEditJob = () => {
    setOriginalJobData({ ...selectedJobDetails });
    setEditedJobData({ ...selectedJobDetails });
    setIsEditingJob(true);
  };

  const resetJobEdit = () => {
    if (originalJobData) {
      setSelectedJobDetails(originalJobData);
      jobEditFormik.setValues({
        title: originalJobData.title || "",
        yearsOfExperience: originalJobData.years_experience?.toString() || "",
        jobLocation: originalJobData.location || "",
        jobType: originalJobData.job_type || "",
        skills: Array.isArray(originalJobData.skills)
          ? originalJobData.skills
          : typeof originalJobData.skills === "string"
            ? [originalJobData.skills]
            : [],
        jobDescription: originalJobData.description || "",
        jobRole: originalJobData.job_role || "",
        salary_min: originalJobData.salary_min?.toString() || "",
        salary_max: originalJobData.salary_max?.toString() || "",
        tags: originalJobData.tags || [],
        openings: originalJobData.openings?.toString() || "",
      });
    }
    setIsEditingJob(false);
    setOriginalJobData(null);
    setEditedJobData(null);
  };

  const handleOpenDeleteJobDialog = () => {
    setOpenJobDeleteDialog(true);
  };

  const handleDeleteJob = async () => {
    try {
      await deleteRequest(
        VYLABS_BASE_URL,
        `${DELETE_JOB}?id=${selectedJobDetails.id}`,
      );
      Toast("success", "Job deleted successfully");
      setClientJobsList((prevJobs) =>
        prevJobs.filter((job) => job.id !== selectedJobDetails.id),
      );
      handleCloseJobDetailsContainer();
    } catch (error) {
      console.error("Error deleting job:", error);
    } finally {
      setOpenJobDeleteDialog(false);
    }
  };

  const handleJobChange = (data) => {
    if (data.validateForm) {
      setJobDetailsValidation(() => data.validateForm);
    } else {
      const updatedValues = {
        ...jobEditFormik.values,
        title: data.title || jobEditFormik.values.title,
        jobRole: data.job_role || jobEditFormik.values.jobRole,
        jobDescription: data.description || jobEditFormik.values.jobDescription,
        skills: data.skills || jobEditFormik.values.skills,
        tags: data.tags || jobEditFormik.values.tags,
        openings: data.openings || jobEditFormik.values.openings,
      };
      jobEditFormik.setValues(updatedValues);
      setEditedJobData((prev) => ({
        ...prev,
        ...data,
        years_experience: jobEditFormik.values.yearsOfExperience,
        location: jobEditFormik.values.jobLocation,
        salary_min: jobEditFormik.values.salary_min,
        salary_max: jobEditFormik.values.salary_max,
        job_type: jobEditFormik.values.jobType,
        openings: jobEditFormik.values.openings,
      }));
    }
  };

  const saveJobChanges = async () => {
    if (jobDetailsValidation) {
      const jobDetailsResult = await jobDetailsValidation();
      if (!jobDetailsResult.isValid) {
        Toast("error", "Please fill all required fields correctly");
        return;
      }
    }

    await jobEditFormik.validateForm();
    if (!jobEditFormik.isValid) {
      jobEditFormik.setTouched({
        title: true,
        jobRole: true,
        jobType: true,
        jobLocation: true,
        yearsOfExperience: true,
        salary_min: true,
        salary_max: true,
        skills: true,
        openings: true,
      });
      Toast("error", "Please fill all required fields correctly");
      return;
    }

    try {
      const jobDetailsResult = await jobDetailsValidation();
      const mainFormValues = jobEditFormik.values;

      const combinedValues = {
        ...mainFormValues,
        title: mainFormValues.title || jobDetailsResult.values.title,
        jobRole: mainFormValues.jobRole || jobDetailsResult.values.job_role,
        jobDescription:
          jobDetailsResult.values.description ||
          mainFormValues.jobDescription ||
          "",
        skills: mainFormValues.skills || jobDetailsResult.values.skills,
        tags: mainFormValues.tags || jobDetailsResult.values.tags,
        openings: mainFormValues.openings || jobDetailsResult.values.openings,
      };

      const skills = Array.isArray(combinedValues.skills)
        ? combinedValues.skills.join(", ")
        : combinedValues.skills || "";

      const tags = Array.isArray(combinedValues.tags)
        ? combinedValues.tags.join(", ")
        : combinedValues.tags || "";

      const jobData = {
        jobID: selectedJobDetails.id,
        jobTitle: combinedValues.title,
        jobRole: combinedValues.jobRole,
        jobType: combinedValues.jobType,
        jobYearsExperience: Number(combinedValues.yearsOfExperience || 0),
        jobSalaryMin: Number(combinedValues.salary_min || 0),
        jobSalaryMax: Number(combinedValues.salary_max || 0),
        jobLocation: combinedValues.jobLocation,
        jobDescription: combinedValues.jobDescription,
        jobSkills: skills,
        jobTags: tags,
        jobOpenings: Number(combinedValues.openings || 0),
      };

      await put(VYLABS_BASE_URL, UPDATE_JOB, jobData);

      const updatedJob = {
        ...selectedJobDetails,
        id: selectedJobDetails.id,
        title: combinedValues.title,
        job_role: combinedValues.jobRole,
        job_type: combinedValues.jobType,
        years_experience: combinedValues.yearsOfExperience,
        salary_min: combinedValues.salary_min,
        salary_max: combinedValues.salary_max,
        location: combinedValues.jobLocation,
        description: combinedValues.jobDescription,
        skills: combinedValues.skills,
        tags: combinedValues.tags,
        openings: combinedValues.openings,
      };

      setSelectedJobDetails(updatedJob);
      setIsEditingJob(false);
      Toast("success", "Job updated successfully");

      setClientJobsList((prevJobs) =>
        prevJobs.map((job) => (job.id === updatedJob.id ? updatedJob : job)),
      );
      handleCloseJobDetailsContainer();
    } catch (error) {
      console.error("Error updating job:", error);
      Toast(
        "error",
        "Failed to update job: " +
          (error.response?.data?.message || error.message),
      );
    }
  };

  useEffect(() => {
    if (selectedJobDetails && !isEditingJob) {
      const initialValues = {
        title: selectedJobDetails.title || "",
        yearsOfExperience:
          selectedJobDetails.years_experience?.toString() || "",
        jobLocation: selectedJobDetails.location || "",
        jobType: selectedJobDetails.job_type || "",
        skills: Array.isArray(selectedJobDetails.skills)
          ? selectedJobDetails.skills
          : typeof selectedJobDetails.skills === "string"
            ? [selectedJobDetails.skills]
            : [],
        jobDescription: selectedJobDetails.description || "",
        jobRole: selectedJobDetails.job_role || "",
        salary_min: selectedJobDetails.salary_min?.toString() || "",
        salary_max: selectedJobDetails.salary_max?.toString() || "",
        tags: selectedJobDetails.tags || [],
        openings: selectedJobDetails.openings?.toString() || "",
      };
      jobEditFormik.setValues(initialValues);
    }
  }, [selectedJobDetails, isEditingJob]);

  const saveClientChanges = async () => {
    if (!selectedClient || !changedClient) {
      Toast("error", "No client selected or initial data missing");
      return;
    }

    try {
      const errors = await formik.validateForm();
      if (Object.keys(errors).length > 0) {
        Object.keys(errors).forEach((key) => {
          formik.setFieldTouched(key, true, false);
        });
        Toast("error", "Please fill all required fields correctly");
        return;
      }

      const payloadValues = {
        name: formik.values.clientName.trim(),
        contactPerson: formik.values.contactPerson.trim(),
        contactDesignation: formik.values.contactDesignation.trim(),
        email: formik.values.email.trim(),
        phone: formik.values.mobile
          ? formik.values.mobile.startsWith("+")
            ? formik.values.mobile
            : `+${formik.values.mobile}`
          : "",
        country: formik.values.country.trim(),
        state: formik.values.state.trim(),
        city: formik.values.city.trim(),
        address: formik.values.address1.trim(),
        address_2: (formik.values.address2 || "").trim(),
        zipCode: formik.values.zipCode.trim(),
        remarks: (formik.values.remarks || "").trim(),
        clientType: (formik.values.clientType || "").trim(),
      };

      const changes = {};
      for (const key in payloadValues) {
        const currentValue = payloadValues[key];
        const originalValue = changedClient[key];

        const normalizedCurrentValue =
          currentValue === null || currentValue === undefined
            ? ""
            : String(currentValue).trim();
        const normalizedOriginalValue =
          originalValue === null || originalValue === undefined
            ? ""
            : String(originalValue).trim();

        if (normalizedCurrentValue !== normalizedOriginalValue) {
          if (
            (key === "address2" || key === "remarks") &&
            (originalValue === null || originalValue === undefined) &&
            normalizedCurrentValue === ""
          ) {
            continue;
          }
          changes[key] = currentValue;
        }
      }

      if (Object.keys(changes).length === 0) {
        Toast("info", "No changes detected");
        setIsEditingClient(false);
        return;
      }

      const payload = {
        id: selectedClient.id,
        ...changes,
      };

      await post(VYLABS_BASE_URL, UPDATE_CLIENT_INFO, payload);
      Toast("success", `${tenantLabel} updated successfully`);

      const updatedClientState = { ...changedClient };
      for (const key in changes) {
        updatedClientState[key] = changes[key];
      }

      setSelectedClient(updatedClientState);
      setChangedClient(updatedClientState);
      setViewClient(false);
      setIsEditingClient(false);
      await fetchAllClientsList(0);
    } catch (error) {
      console.error("Error updating client:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        `Failed to update ${tenantLabelLower}. Please try again.`;
      Toast("error", errorMessage);
    }
  };

  useEffect(() => {
    if (!selectedClient) return;
    if (activeTab === "Jobs") {
      setClientJobsList([]);
      setClientJobsListOffset(0);
      setClientJobsListHasMore(true);
    }
  }, [activeTab, selectedClient]);

  useEffect(() => {
    if (activeTab !== "Jobs" || !selectedClient) return;
    fetchClientJobs(clientJobsListOffset);
  }, [clientJobsListOffset, activeTab, selectedClient]);

  const renderContent = () => {
    switch (activeTab) {
      case "Jobs":
        return (
          <ClientJobs
            clientId={selectedClient?.id}
            onOpenJobDetails={(job, index, tab, isEditing = false) => {
              setJobDetailsActiveTab(tab);
              handleOpenJobDetailsContainer(job, index, tab);
              if (isEditing) {
                setIsEditingJob(true);
              }
            }}
            jobsListLastElement={jobsListLastElement}
            setClientJobsList={setClientJobsList}
            clientJobsList={clientJobsList}
            isInitialLoading={isInitialLoading}
            setIsInitialLoading={setIsInitialLoading}
            isLoadingMore={isLoadingMore}
            setIsLoadingMore={setIsLoadingMore}
            clientJobsListHasMore={clientJobsListHasMore}
            setClientJobsListHasMore={setClientJobsListHasMore}
            showLoader={showLoader}
            setShowLoader={setShowLoader}
          />
        );

      case "Tracking":
        return (
          <ClientTracking
            clientId={selectedClient?.id}
            clientPriority={clientPriority}
            clientStatus={activeClientStatusOptions}
            selectedClient={selectedClient}
            contactOptions={contactOptions}
            setSelectedContactId={setSelectedContactId}
            editFormik={editFormik}
            handleTriggerClear={handleTriggerClear}
            clearTriggered={clearTriggered}
            setClearTriggered={setClearTriggered}
            trackingRefreshKey={trackingRefreshKey}
            isDarkMode={isDarkMode}
            reminderFormik={reminderFormik}
            editRemainderFormik={editRemainderFormik}
            showReminderDialog={showReminderDialog}
            onOpenReminderDialog={handleOpenReminderDialog}
            onCloseReminderDialog={handleCloseReminderDialog}
            onSubmitReminder={handleSetReminderSubmit}
            fetchCallbackReminders={fetchCallbackReminders}
            callbackRemainderRes={callbackRemainderRes}
            handleDeleteCallbackRemainder={handleDeleteCallbackRemainder}
            isHiringTeamTenant={isHiringTeamTenant}
          />
        );

      case "Additional Contacts":
        return (
          <ClientAdditionalContacts
            contacts={selectedClient?.contacts || []}
            onAddContact={handleOpenAddContactPopup}
            onViewContact={handleOpenViewContactPopup}
            onEditContact={handleOpenEditContactPopup}
            onDeleteContact={handleOpenDeleteContactPopup}
            isDarkMode={isDarkMode}
            clientId={selectedClient?.id}
          />
        );

      case "Documents":
        return <ClientDocuments clientId={selectedClient?.id} />;

      default:
        return null;
    }
  };
  const handleOpenClientDeleteDialog = () => {
    setIsClientDeleteDialogOpen(true);
  };
  return (
    <div>
      <JobStatusUpdatePopup />
      <div className="header-main-container">
        <div className="header-icon-title-container">
          <img
            alt=""
            className="header-title-icon"
            src={isDarkMode ? clientsPageDarkIcon : clientsPageIcon}
          />
          <h2 className="header-container">
            {isHiringTeamTenant ? "Hiring Team" : "Clients"}
          </h2>
        </div>
        <div
          className="client-header-button-container"
          style={{ width: "100%" }}
        >
          <div className="selection-actions">
            <div className="select-button-container">
              {!isImportOpen && !isHiringTeamTenant && (
                <Button
                  label="Import Clients"
                  event={() => setIsImportOpen(true)}
                  iconSrc={importIcon}
                  iconWidth="23px"
                  style={{
                    color: "var(--header__color)",
                    backgroundColor: "var(--body__background)",
                    border: "1px solid var(--border__color)",
                  }}
                  hoverd={false}
                />
              )}
              {isImportOpen && (
                <Button
                  label="Back to Clients"
                  event={() => {
                    setIsImportOpen(false);
                    handleBackToClientsList();
                    setShowSpreadsheetResults(false);
                    setUploadedResumes([]);
                    setSpreadsheetLoading(false);
                  }}
                  iconSrc={backArrowIcon}
                />
              )}
              <Button
                label="Create"
                event={handleOpenInviteModal}
                iconSrc={addIcon}
                iconWidth="15px"
                className="create-button"
                style={{ padding: "5px 10px" }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="client-page-outer-container">
        {hasClientProfiles && !isImportOpen && (
          <div className="client-search-container-wrap">
            <div className="page-selector-container">
              <GlobalSearchBox
                isDarkMode={isDarkMode}
                titleIconDark={ClientSearchDarkIcon}
                titleIconLight={ClientSearchLightIcon}
                titleIconAlt={
                  isHiringTeamTenant ? "Hiring Team Search" : "Client Search"
                }
                value={searchQuery}
                onChange={handleInputChange}
                onSearch={handleClientSearch}
                suggestions={filteroptions}
                showClearSearch={hasSearched}
                onClear={handleBackToClientsList}
                placeholder={
                  isHiringTeamTenant
                    ? "Search using Hiring Team Name, contact name , or email"
                    : "Search using client name, contact name , or email"
                }
                subText=""
                searchTitle={
                  isHiringTeamTenant ? "Hiring Team Search" : "Client Search"
                }
                buttonLabel="Search"
                resetKey={searchResetKey}
                filter="true"
                onFilterClick={onFilterClick}
                filterOptions={filteroptions}
                askmeanythingOnKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    handleClientSearch();
                  }
                }}
                enableGlobalEnter={true}
              />
            </div>
            <div
              className="jobs-status-and-view-switcher"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <div className="jobs-list-buttons">
                {hasSearched || activeClientFilterType ? (
                  <div className="back-to-clients-list-button">
                    <Button
                      label={
                        isHiringTeamTenant
                          ? "Back to Hiring Team"
                          : "Back to Clients List"
                      }
                      event={handleBackToClientsList}
                      iconSrc={rightArrowIcon}
                      className={`can-btn ${"active"}`}
                      style={{ marginBottom: "-10px" }}
                    />
                  </div>
                ) : clientList.length > 0 ? (
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "var(--page_Header_Color)",
                      whiteSpace: "nowrap",
                      marginLeft: "12px",
                    }}
                  >
                    All {isHiringTeamTenant ? "Hiring Team" : "Clients"}
                  </h3>
                ) : null}
              </div>
              <div className="jobs-right-controls">
                <div
                  className="filter-stages-and-popup"
                  style={{ display: "flex" }}
                  ref={clientFilterContainerRef}
                >
                  <Button
                    iconSrc={isDarkMode ? filterDarkIcon : filterIcon}
                    iconPosition="left"
                    iconStyle={{ marginRight: "8px" }}
                    event={() => setIsClientFilterOpen((prev) => !prev)}
                    disabled={isInitialLoading || isLoadingMore}
                    className={`filter-stages-btn`}
                  />
                  <ClientFilters
                    isOpen={isClientFilterOpen}
                    onClose={() => setIsClientFilterOpen(false)}
                    onApply={(data) => {
                      let filterType = "";
                      let filterUserId = "";
                      if (data.isTrackedByMeActive) {
                        filterType = "tracked";
                        filterUserId = userDetails?.id;
                      } else if (data.isCreatedByMeActive) {
                        filterType = "created";
                        filterUserId = userDetails?.id;
                      }
                      setActiveClientFilterType(filterType);
                      setActiveClientFilterUserId(filterUserId);
                      setActiveClientFilterFromDate(data.fromDate || "");
                      setActiveClientFilterEndDate(data.endDate || "");
                      setCreatedByUserId(data.userId);
                      setIsTrackedByMeActive(data.isTrackedByMeActive);
                      setIsCreatedByMeActive(data.isCreatedByMeActive);
                      setIsClientFilterOpen(false);
                      setClientListOffset(0);
                    }}
                    initialUserId={createdByUserId}
                    setActiveClientFilterType={setActiveClientFilterType}
                    setActiveClientFilterUserId={setActiveClientFilterUserId}
                    initialIsTracked={isTrackedByMeActive}
                    initialIsCreated={isCreatedByMeActive}
                    initialFromDate={activeClientFilterFromDate}
                    initialEndDate={activeClientFilterEndDate}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {useEffect(() => {
          if (!isClientFilterOpen) return;

          const handleClickOutside = (event) => {
            const isInsideMuiPortal =
              event.target.closest?.(".MuiAutocomplete-popper") ||
              event.target.closest?.(".MuiPopover-root") ||
              event.target.closest?.(".MuiAutocomplete-listbox");

            if (isInsideMuiPortal) return;

            if (
              clientFilterContainerRef.current &&
              !clientFilterContainerRef.current.contains(event.target)
            ) {
              setIsClientFilterOpen(false);
            }
          };

          const handleEscape = (event) => {
            if (event.key === "Escape") {
              setIsClientFilterOpen(false);
            }
          };

          document.addEventListener("mousedown", handleClickOutside);
          document.addEventListener("keydown", handleEscape);
          return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEscape);
          };
        }, [isClientFilterOpen])}

        {!isImportOpen && (
          <div className="client-page-inner-container">
            {isCreatingClient ||
            !isFetchCompleted ||
            (isInitialLoading && !isLoadingMore) ? (
              <div className="inner-page-outer-container">
                <div className="client-cards-container">
                  {Array.from({ length: 30 }).map((_, index) => (
                    <DynamicSkeleton
                      key={index}
                      variant="rectangular"
                      dimensions={{
                        width: "100%",
                        height: "200px",
                        sx: { borderRadius: "16px" },
                      }}
                    />
                  ))}
                </div>
              </div>
            ) : clientList.length > 0 ? (
              <div className="client-cards-container">
                {clientList.map((client, index) => (
                  <div
                    key={index}
                    className="client-card-outer-container"
                    ref={index === clientList.length - 1 ? lastElement : null}
                  >
                    <ClientCard
                      key={client.id}
                      client={client}
                      viewClient={() => {
                        getClientDetails(client.id);
                      }}
                      editClient={(clientId) => {
                        getClientDetails(clientId);
                        setTimeout(() => {
                          setIsEditingClient(true);
                        }, 300);
                      }}
                    />
                  </div>
                ))}
                {isLoadingMore && (
                  <>
                    {Array.from({ length: 30 }).map((_, idx) => (
                      <DynamicSkeleton
                        key={`scroll-skeleton-${idx}`}
                        variant="rectangular"
                        dimensions={{
                          width: "100%",
                          height: "200px",
                          sx: { borderRadius: "16px" },
                        }}
                      />
                    ))}
                  </>
                )}
              </div>
            ) : activeClientFilterType ? (
              <div className="client-workspace-outer-main-container">
                <div className="client-workspace-outer-container">
                  <h3>
                    No {activeClientFilterType} {tenantLabelLowerPlural} found
                  </h3>
                  <AnimationPlayer
                    animationSrc={NoDataFoundAnimation}
                    playerHeight="300px"
                    playerWidth="300px"
                  />
                </div>
              </div>
            ) : hasSearched ? (
              <div className="client-workspace-outer-main-container">
                <div className="client-workspace-outer-container">
                  <h3>No Search Results Found</h3>
                  <AnimationPlayer
                    animationSrc={sendIconDarkAnimation}
                    playerHeight="300px"
                    playerWidth="300px"
                  />
                </div>
              </div>
            ) : isInitialLoading || isLoadingMore ? (
              <div className="workspace-outer-main-container-loader">
                <VybogTALLoaderAnimation />
              </div>
            ) : (
              <div className="client-workspace-outer-main-container">
                <div className="client-workspace-outer-container">
                  <div
                    className="create-text-content"
                    style={{ marginTop: "100px" }}
                  >
                    <img
                      src={isDarkMode ? createDarkClientIcon : createClientIcon}
                      alt="InterviewIcon"
                      className="interview-icon"
                      style={{ marginBottom: "-40px", marginLeft: "90px" }}
                    />
                    <h3>
                      Create a{" "}
                      <span className="inner-span">New {tenantLabel}</span>
                    </h3>
                    <p>
                      {isHiringTeamTenant ? "Hiring Team" : "Clients"} include
                      jobs and suitable candidates to be scheduled for
                      interviews
                    </p>
                    <div className="client-workspace-button-container">
                      <Button
                        label={
                          isHiringTeamTenant
                            ? "Create Hiring Team"
                            : "Create Client"
                        }
                        event={handleOpenInviteModal}
                        className="create-button"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        <SidePopup
          isOpen={isModalOpen}
          onClose={handleCloseInviteModal}
          title={isHiringTeamTenant ? "Create Hiring Team" : "Create Client"}
          sidePopupWidth={"var(--client-side-popup-w)"}
        >
          <div className="client-popup-container">
            <div className="create-client-details">
              <DynamicTextField
                label={isHiringTeamTenant ? "Hiring Team Name" : "Client Name"}
                type="text"
                name="clientName"
                placeholder={
                  isHiringTeamTenant
                    ? "e.g. Finance Hiring Team"
                    : "e.g. StriveTech Inc."
                }
                value={formik.values.clientName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.clientName && formik.errors.clientName}
                errorMessage={formik.errors.clientName}
                style={{ width: "100%" }}
                labelStyle={{ marginBottom: "10px" }}
                required={true}
              />
              <div className="textfield-container">
                <SelectInput
                  label="Priority"
                  options={clientPriority}
                  name="clientPriority"
                  value={formik.values.clientPriority}
                  onChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldTouched("clientPriority", true);
                  }}
                  onBlur={() => formik.setFieldTouched("clientPriority", true)}
                  error={
                    formik.touched.clientPriority &&
                    Boolean(formik.errors.clientPriority) &&
                    !formik.values.clientPriority
                  }
                  errorMessage={
                    formik.touched.clientPriority &&
                    formik.errors.clientPriority &&
                    !formik.values.clientPriority
                      ? formik.errors.clientPriority
                      : ""
                  }
                  labelStyle={{ marginBottom: "10px", fontWeight: "600" }}
                  className="textfield-label"
                  required={true}
                />
              </div>
              <div className="textfield-container">
                <SelectInput
                  label={isHiringTeamTenant ? "Activity" : "Company Status"}
                  options={activeClientStatusOptions}
                  name="clientStatus"
                  value={formik.values.clientStatus}
                  onChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldTouched("clientStatus", true);
                  }}
                  onBlur={() => formik.setFieldTouched("clientStatus", true)}
                  error={
                    formik.touched.clientStatus &&
                    Boolean(formik.errors.clientStatus) &&
                    !formik.values.clientStatus
                  }
                  errorMessage={
                    formik.touched.clientStatus &&
                    formik.errors.clientStatus &&
                    !formik.values.clientStatus
                      ? formik.errors.clientStatus
                      : ""
                  }
                  labelStyle={{ marginBottom: "10px", fontWeight: "600" }}
                  className="textfield-label"
                  required={true}
                />
              </div>
              <div className="textfield-container">
                <DynamicTextField
                  label={isHiringTeamTenant ? "Division" : "Client Type"}
                  type="text"
                  name="clientType"
                  placeholder={
                    isHiringTeamTenant
                      ? "e.g. Frontend Team, Backend Team"
                      : "e.g. Enterprise, Startup"
                  }
                  value={formik.values.clientType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.clientType && formik.errors.clientType}
                  errorMessage={formik.errors.clientType}
                  style={{ width: "100%" }}
                  labelStyle={{ marginBottom: "10px" }}
                  required={false}
                />
              </div>
            </div>
            <h3 style={{ width: "fit-content" }}>
              {tenantLabel} Contact Details
            </h3>
            <div className="create-client-contact-details">
              <DynamicTextField
                label="Contact Person"
                type="text"
                name="contactPerson"
                placeholder="e.g. Marcus Nguyen"
                value={formik.values.contactPerson}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.contactPerson && formik.errors.contactPerson
                }
                errorMessage={formik.errors.contactPerson}
                labelStyle={{ marginBottom: "10px" }}
                required={true}
              />
              <DynamicTextField
                label="Contact Designation"
                type="text"
                name="contactDesignation"
                placeholder={
                  isHiringTeamTenant
                    ? "e.g. Hiring Manager"
                    : "e.g. Technical Recruiter"
                }
                value={formik.values.contactDesignation}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.contactDesignation &&
                  formik.errors.contactDesignation
                }
                errorMessage={formik.errors.contactDesignation}
                labelStyle={{ marginBottom: "10px" }}
                required={true}
              />
            </div>
            <div className="create-clients-contact-details">
              <DynamicTextField
                label="Email"
                type="email"
                name="email"
                placeholder="e.g. marcus.nguyen@strivetech.com"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && formik.errors.email}
                errorMessage={formik.errors.email}
                required={true}
                labelStyle={{ marginBottom: "10px" }}
              />
              <PhoneNumberInput
                value={formik.values.mobile}
                onChange={handlePhoneInputChange}
                onBlur={() => formik.setFieldTouched("mobile", true)}
                error={formik.errors.mobile}
                touched={formik.touched.mobile}
                placeholder="e.g. (415) 555-0198"
                label="Contact No."
                width="100%"
                height="40px"
                countryListWidth="300px"
                phoneContainerStyle={{ marginBottom: "15px" }}
                required={true}
              />
            </div>

            <div className="create-client-location-details">
              <h3>
                {isHiringTeamTenant
                  ? "Hiring Team Location Details"
                  : "Client Location Details"}{" "}
              </h3>
              <div className="create-address-container">
                <DynamicTextField
                  label="Address Line 1"
                  name="address1"
                  placeholder="Enter Your Address Line 1"
                  value={formik.values.address1}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.address1 && formik.errors.address1}
                  errorMessage={formik.errors.address1}
                  style={{ width: "100%" }}
                  labelStyle={{ marginBottom: "10px" }}
                />
                <DynamicTextField
                  label="Address Line 2 (Optional)"
                  name="address2"
                  placeholder="Enter Your Address Line 2"
                  value={formik.values.address2}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.address2 && formik.errors.address2}
                  errorMessage={formik.errors.address2}
                  style={{ width: "100%" }}
                  labelStyle={{ marginBottom: "10px" }}
                />
              </div>

              <div className="create-client-location-container">
                <DynamicTextField
                  label="Country"
                  name="country"
                  placeholder="Country"
                  value={formik.values.country}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.country && formik.errors.country}
                  errorMessage={formik.errors.country}
                  style={{ width: "90%" }}
                  labelStyle={{ marginBottom: "10px" }}
                />
                <DynamicTextField
                  label="State"
                  name="state"
                  placeholder="State"
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.state && formik.errors.state}
                  errorMessage={formik.errors.state}
                  style={{ width: "90%" }}
                  labelStyle={{ marginBottom: "10px" }}
                />
                <DynamicTextField
                  label="City"
                  name="city"
                  placeholder="City"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.city && formik.errors.city}
                  errorMessage={formik.errors.city}
                  style={{ width: "90%" }}
                  labelStyle={{ marginBottom: "10px" }}
                />
                <DynamicTextField
                  label="Zipcode"
                  name="zipCode"
                  placeholder="Zipcode"
                  value={formik.values.zipCode}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.zipCode && formik.errors.zipCode}
                  errorMessage={formik.errors.zipCode}
                  style={{ width: "90%" }}
                  labelStyle={{ marginBottom: "10px" }}
                />
              </div>
              <div className="skill-header" style={{ marginBottom: "9px" }}>
                <div className="skill-title">
                  {" "}
                  <h3
                    className="desc-inner-header textfield-label"
                    style={{ margin: 0 }}
                  >
                    Remarks
                  </h3>
                  <span className="required-asterisk">*</span>
                </div>
              </div>
              <div>
                <TextArea
                  placeholder={"Enter Remarks"}
                  name="remarks"
                  value={formik.values.remarks}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.remarks && formik.errors.remarks}
                  errorMessage={formik.errors.remarks}
                />
              </div>
            </div>
            <div className="client-creation-button-container">
              <Button
                label="Cancel"
                event={handleCloseInviteModal}
                backgroundColor="#6860ee"
                isCancel={true}
              />
              <Button
                label={
                  isCreatingClient
                    ? "Creating..."
                    : isHiringTeamTenant
                      ? "Create Hiring Team"
                      : "Create Client"
                }
                event={handleCreateClient}
                backgroundColor="#6860ee"
                className="create-button"
                disabled={isCreatingClient}
                hoverd={!isCreatingClient}
                style={{
                  opacity: isCreatingClient ? 0.6 : 1,
                }}
              />
            </div>
          </div>
        </SidePopup>
        <SidePopup
          isOpen={viewClient}
          onClose={() => {
            handleCloseClientDetails();
          }}
          title={
            <CustomTooltip title={selectedClient?.name} arrow>
              <span>{applyEllipsis(selectedClient?.name, 30)}</span>
            </CustomTooltip>
          }
          sidePopupStyle={{
            width: "80%",
          }}
          headerRightContent={
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              {selectedClient && (
                <div className="client-create-update-details">
                  <div className="company-dates">
                    <span>
                      Created at :{" "}
                      {formatDateWithUserTimezone(selectedClient?.created_at) ||
                        "N/A"}
                    </span>
                    {/* <span>
                      Updated at :{" "}
                      {formatDateWithUserTimezone(selectedClient?.updated_at, false, true) ||
                        "N/A"}
                    </span> */}
                  </div>
                  {userDetails?.tenant_id ===
                  "8d01a95f87c7465a9b11998555631f66" ? null : (
                    <div className="company-dates">
                      <span>Created By : {clientCreatedUserName}</span>
                    </div>
                  )}
                </div>
              )}
              {isEditingClient ? (
                <>
                  <Button
                    label="Save"
                    event={saveClientChanges}
                    style={{ padding: "8px 15px" }}
                    backgroundColor="#6860EE"
                    color="#FFFFFF"
                    border="none"
                  />
                  <Button
                    label="Cancel"
                    event={handleCancelEditClient}
                    style={{ padding: "8px 15px" }}
                    backgroundColor="#fff"
                    color="#000"
                    border="1px solid #ddd"
                  />
                </>
              ) : (
                <CustomTooltip title={`Edit ${tenantLabel}`} arrow>
                  <img
                    src={editIcon}
                    alt="Edit"
                    onClick={handleEditClient}
                    style={{ cursor: "pointer", width: "22px" }}
                  />
                </CustomTooltip>
              )}
              {!isEditingClient && !MemberAccess && (
                <CustomTooltip title={`Delete ${tenantLabel}`} arrow>
                  <img
                    src={deleteIcon}
                    alt="Delete"
                    onClick={handleOpenClientDeleteDialog}
                    style={{ cursor: "pointer", width: "22px" }}
                  />
                </CustomTooltip>
              )}
            </div>
          }
        >
          {selectedClient && (
            <div className="client-main-container">
              {isEditingClient && (
                <div className="client-name-edit">
                  <TextInput
                    label={
                      isHiringTeamTenant ? "Hiring Team Name" : "Client Name"
                    }
                    name="clientName"
                    placeholder={
                      isHiringTeamTenant ? "Hiring Team Name" : "Client Name"
                    }
                    required={true}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.clientName && formik.errors.clientName
                    }
                    errorMessage={formik.errors.clientName}
                    value={formik.values.clientName}
                    onChange={formik.handleChange}
                  />
                </div>
              )}
              <div
                style={{
                  padding: "0px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div
                  className={`client-candidate-info-outer-container ${
                    isEditingClient ? "edit-mode" : ""
                  }`}
                >
                  <div className="candidate-information">
                    <div className="info-header">
                      <img
                        src={accountIcon}
                        alt="company-icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <h4 className="info-header-value">
                        Contact Person{" "}
                        {isEditingClient && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </h4>
                    </div>

                    <div className="detail-content">
                      {isEditingClient ? (
                        <TextInput
                          placeholder="Contact Person"
                          name="contactPerson"
                          value={formik.values.contactPerson}
                          required={true}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.contactPerson &&
                            formik.errors.contactPerson
                          }
                          errorMessage={formik.errors.contactPerson}
                          onChange={formik.handleChange}
                        />
                      ) : (
                        <span className="candidate-email">
                          {selectedClient?.contact_person || "N/A"}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="candidate-information">
                    <div className="info-header">
                      <img
                        src={jobIcon}
                        alt="job-icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <h4 className="info-header-value">
                        Contact Designation{" "}
                        {isEditingClient && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </h4>
                    </div>

                    <div className="detail-content">
                      {isEditingClient ? (
                        <TextInput
                          name="contactDesignation"
                          placeholder="Designation"
                          value={formik.values.contactDesignation}
                          required={true}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.contactDesignation &&
                            formik.errors.contactDesignation
                          }
                          errorMessage={formik.errors.contactDesignation}
                          onChange={formik.handleChange}
                        />
                      ) : (
                        <span className="candidate-email">
                          {selectedClient?.contact_designation || "N/A"}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="candidate-information">
                    <div className="info-header">
                      <img
                        src={mailIcon}
                        alt="mail-icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <h4 className="info-header-value">
                        Email{" "}
                        {isEditingClient && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </h4>
                    </div>
                    <div className="detail-content">
                      {isEditingClient ? (
                        <TextInput
                          placeholder="Email"
                          name="email"
                          type="email"
                          value={formik.values.email}
                          required={true}
                          onBlur={formik.handleBlur}
                          error={formik.touched.email && formik.errors.email}
                          errorMessage={formik.errors.email}
                          onChange={formik.handleChange}
                        />
                      ) : (
                        <h5 className="client-details-value">
                          {selectedClient?.email || "N/A"}
                        </h5>
                      )}
                    </div>
                  </div>
                  <div className="candidate-information">
                    <div className="info-header">
                      <img
                        src={phoneIcon}
                        alt="phone-icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <h4 className="info-header-value">
                        Phone{" "}
                        {isEditingClient && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </h4>
                    </div>
                    <div className="detail-content">
                      {isEditingClient ? (
                        <PhoneNumberInput
                          value={formik.values.mobile}
                          onChange={handlePhoneInputChange}
                          onBlur={formik.handleBlur}
                          error={formik.errors.mobile}
                          touched={formik.touched.mobile}
                          placeholder="e.g. (415) 555-0198"
                          width="100%"
                          height="40px"
                          countryListWidth="300px"
                          phoneContainerStyle={{ marginBottom: "15px" }}
                          required={true}
                        />
                      ) : (
                        <h5 className="client-details-value">
                          {selectedClient?.phone || "N/A"}
                        </h5>
                      )}
                    </div>
                  </div>
                  <div className="candidate-information">
                    <div className="info-header">
                      <img
                        src={jobIcon}
                        alt="job-icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <h4 className="info-header-value">
                        {isHiringTeamTenant ? "Division" : "Client Type"}
                      </h4>
                    </div>

                    <div className="detail-content">
                      {isEditingClient ? (
                        <TextInput
                          name="clientType"
                          placeholder={
                            isHiringTeamTenant
                              ? "e.g. Frontend Team, Backend Team"
                              : "e.g. Enterprise, Startup"
                          }
                          required={false}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.clientType &&
                            formik.errors.clientType
                          }
                          errorMessage={formik.errors.clientType}
                          value={formik.values.clientType}
                          onChange={formik.handleChange}
                        />
                      ) : (
                        <span className="candidate-email">
                          {selectedClient?.client_type || "N/A"}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="client-details-container">
                  <div className="client-details-inner-container">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 0,
                        gap: "48px",
                        marginBottom: "20px",
                      }}
                    >
                      <div className="info-header">
                        <img
                          src={locationIcon}
                          alt="location-icon"
                          style={{ width: "20px", height: "20px" }}
                        />
                        <span
                          className="detail-label"
                          style={{
                            color: "#6a69eb",
                            fontSize: "20px",
                            fontWeight: "500",
                          }}
                        >
                          {isHiringTeamTenant
                            ? "Hiring Team Location Details"
                            : "Client Location Details"}{" "}
                        </span>
                      </div>
                    </div>
                    <div className="candidate-information">
                      <div className="detail-content">
                        {isEditingClient ? (
                          <>
                            <div className="location-inputs">
                              <TextInput
                                label="Address Line 1"
                                name="address1"
                                placeholder="Enter your address Line 1"
                                value={formik.values.address1}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.address1 &&
                                  formik.errors.address1
                                }
                                errorMessage={formik.errors.address1}
                                onChange={formik.handleChange}
                              />
                              <TextInput
                                label="Address Line 2 (Optional)"
                                name="address2"
                                placeholder="Enter your address line 2"
                                value={formik.values.address2}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.address2 &&
                                  formik.errors.address2
                                }
                                errorMessage={formik.errors.address2}
                                onChange={formik.handleChange}
                              />
                            </div>
                            <div className="location-inputs">
                              <TextInput
                                label="City"
                                name="city"
                                placeholder="City"
                                value={formik.values.city}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.city && formik.errors.city
                                }
                                errorMessage={formik.errors.city}
                                onChange={formik.handleChange}
                              />
                              <TextInput
                                label="State"
                                name="state"
                                placeholder="State"
                                value={formik.values.state}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.state && formik.errors.state
                                }
                                errorMessage={formik.errors.state}
                                onChange={formik.handleChange}
                              />
                              <TextInput
                                label="Country"
                                name="country"
                                placeholder="Country"
                                value={formik.values.country}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.country &&
                                  formik.errors.country
                                }
                                errorMessage={formik.errors.country}
                                onChange={formik.handleChange}
                              />
                              <TextInput
                                label="Zipcode"
                                name="zipCode"
                                placeholder="Zipcode"
                                value={formik.values?.zipCode}
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched.zipCode &&
                                  formik.errors.zipCode
                                }
                                errorMessage={formik.errors.zipCode}
                                onChange={formik.handleChange}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="address-outer-container">
                              <div className="address-containers">
                                <label>Address Line 1: </label>
                                <h5 className="client-details-value">
                                  {selectedClient?.address || "N/A"}
                                </h5>
                              </div>
                              {selectedClient?.address_2 && (
                                <div className="address-containers">
                                  <label>Address Line 2: </label>
                                  <h5 className="client-details-value">
                                    {selectedClient?.address_2 || "N/A"}
                                  </h5>
                                </div>
                              )}

                              <div className="address-containers">
                                <label>City : </label>
                                <h5 className="client-details-value">
                                  {selectedClient?.city || "N/A"}
                                </h5>
                              </div>
                              <div className="address-containers">
                                <label>State : </label>
                                <h5 className="client-details-value">
                                  {selectedClient?.state || "N/A"}
                                </h5>
                              </div>
                              <div className="address-containers">
                                <label>Country : </label>
                                <h5 className="client-details-value">
                                  {selectedClient?.country || "N/A"}
                                </h5>
                              </div>
                              <div className="address-containers">
                                <label>Zipcode : </label>
                                <h5 className="client-details-value">
                                  {selectedClient?.zip_code || "N/A"}
                                </h5>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="client-tabs-container">
                  <div
                    className={`tab ${
                      activeTab === "Jobs" ? "job-tab-active" : ""
                    }`}
                    onClick={() => setActiveTab("Jobs")}
                  >
                    Jobs
                  </div>
                  <div
                    className={`tab ${
                      activeTab === "Tracking" ? "job-tab-active" : ""
                    }`}
                    onClick={() => setActiveTab("Tracking")}
                  >
                    Tracking
                  </div>
                  {!isHiringTeamTenant && (
                    <div
                      className={`tab ${
                        activeTab === "Additional Contacts"
                          ? "job-tab-active"
                          : ""
                      }`}
                      onClick={() => setActiveTab("Additional Contacts")}
                    >
                      Additional Contacts
                    </div>
                  )}
                  <div
                    className={`tab ${activeTab === "Documents" ? "job-tab-active" : ""}`}
                    onClick={() => setActiveTab("Documents")}
                  >
                    Documents
                  </div>
                </div>
              </div>
              <ContentDialog
                isOpen={showClientContactPopup}
                onClose={handleCloseContactPopup}
                onCloseIconClose={handleCloseContactPopup}
                submitButtonLabel="Add"
                cancelButtonLabel="Cancel"
                event={contactFormik.handleSubmit}
                contentWidth="45vw"
                contentHeight={"auto"}
                title={`Add ${tenantLabel} Contact`}
              >
                <div
                  className="add-client-contact-container"
                  style={{ padding: "25px" }}
                >
                  <DynamicTextField
                    label="Contact Person Name"
                    type="text"
                    name="contactName"
                    placeholder="e.g. Alicia Carter."
                    value={contactFormik.values.contactName}
                    onChange={contactFormik.handleChange}
                    onBlur={contactFormik.handleBlur}
                    error={
                      contactFormik.touched.contactName &&
                      contactFormik.errors.contactName
                    }
                    errorMessage={contactFormik.errors.contactName}
                    style={{ width: "100%" }}
                    labelStyle={{ marginBottom: "10px" }}
                    required={true}
                  />
                  <DynamicTextField
                    label="Contact Person Email"
                    type="email"
                    name="contactEmail"
                    placeholder="e.g. marcus.nguyen@strivetech.com"
                    value={contactFormik.values.contactEmail}
                    onChange={contactFormik.handleChange}
                    onBlur={contactFormik.handleBlur}
                    error={
                      contactFormik.touched.contactEmail &&
                      contactFormik.errors.contactEmail
                    }
                    errorMessage={contactFormik.errors.contactEmail}
                    required={true}
                    labelStyle={{ marginBottom: "10px" }}
                  />
                  <PhoneNumberInput
                    value={contactFormik.values.contactPhoneNumber}
                    onChange={handleContactPhoneInputChange}
                    onBlur={() =>
                      contactFormik.setFieldTouched("contactPhoneNumber", true)
                    }
                    error={contactFormik.errors.contactPhoneNumber}
                    touched={contactFormik.touched.contactPhoneNumber}
                    placeholder="e.g. (415) 555-0198"
                    label="Contact Person Contact No."
                    width="100%"
                    height="40px"
                    countryListWidth="300px"
                    phoneContainerStyle={{ marginBottom: "15px" }}
                    required={true}
                  />
                  <DynamicTextField
                    label="Contact Person Designation"
                    type="text"
                    name="contactDesignation"
                    placeholder={
                      isHiringTeamTenant
                        ? "e.g. Hiring Manager"
                        : "e.g. Technical Recruiter"
                    }
                    value={contactFormik.values.contactDesignation}
                    onChange={contactFormik.handleChange}
                    onBlur={contactFormik.handleBlur}
                    error={
                      contactFormik.touched.contactDesignation &&
                      contactFormik.errors.contactDesignation
                    }
                    errorMessage={contactFormik.errors.contactDesignation}
                    style={{ width: "100%" }}
                    labelStyle={{ marginBottom: "10px" }}
                    required={true}
                  />
                  <DynamicTextField
                    label="Contact Person Location"
                    type="text"
                    name="contactLocation"
                    placeholder="e.g. New York, USA"
                    value={contactFormik.values.contactLocation}
                    onChange={contactFormik.handleChange}
                    onBlur={contactFormik.handleBlur}
                    error={
                      contactFormik.touched.contactLocation &&
                      contactFormik.errors.contactLocation
                    }
                    errorMessage={contactFormik.errors.contactLocation}
                    style={{ width: "100%" }}
                    labelStyle={{ marginBottom: "10px" }}
                    required={true}
                  />
                </div>
              </ContentDialog>
              <ContentDialog
                isOpen={showEditContactPopup}
                onClose={handleCloseContactPopup}
                onCloseIconClose={handleCloseContactPopup}
                submitButtonLabel={isViewingContact ? null : "Update"}
                cancelButtonLabel={isViewingContact ? "Close" : "Cancel"}
                event={isViewingContact ? null : contactFormik.handleSubmit}
                showActionButton={!isViewingContact}
                contentWidth="45vw"
                title={
                  isViewingContact
                    ? `View ${tenantLabel} Contact`
                    : `Edit ${tenantLabel} Contact`
                }
              >
                <div
                  className={`add-client-contact-container ${
                    isViewingContact ? "view-contact-details-container" : ""
                  }`}
                  style={{ padding: "25px" }}
                >
                  {isViewingContact ? (
                    <>
                      {[
                        {
                          icon: accountIcon,
                          label: "Contact Person Name",
                          value: contactFormik.values.contactName,
                        },
                        {
                          icon: mailIcon,
                          label: "Contact Person Email",
                          value: contactFormik.values.contactEmail,
                        },
                        {
                          icon: phoneIcon,
                          label: "Contact Person Contact No.",
                          value: contactFormik.values.contactPhoneNumber,
                        },
                        {
                          icon: jobIcon,
                          label: "Contact Person Designation",
                          value: contactFormik.values.contactDesignation,
                        },
                        {
                          icon: locationViewIcon,
                          label: "Contact Person Location",
                          value: contactFormik.values.contactLocation,
                        },
                      ].map((detail) => (
                        <div
                          className="view-contact-detail-item"
                          key={detail.label}
                        >
                          <div className="view-contact-detail-label">
                            <img src={detail.icon} alt="" />
                            <span>{detail.label}</span>
                          </div>
                          <p className="view-contact-detail-value">
                            {detail.value || "N/A"}
                          </p>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      <DynamicTextField
                        label="Contact Person Name"
                        type="text"
                        name="contactName"
                        placeholder="e.g. Alicia Carter."
                        value={contactFormik.values.contactName}
                        onChange={contactFormik.handleChange}
                        onBlur={contactFormik.handleBlur}
                        error={
                          contactFormik.touched.contactName &&
                          contactFormik.errors.contactName
                        }
                        errorMessage={contactFormik.errors.contactName}
                        style={{ width: "100%" }}
                        labelStyle={{ marginBottom: "10px" }}
                        required={true}
                      />
                      <DynamicTextField
                        label="Contact Person Email"
                        type="email"
                        name="contactEmail"
                        placeholder="e.g. marcus.nguyen@strivetech.com"
                        value={contactFormik.values.contactEmail}
                        onChange={contactFormik.handleChange}
                        onBlur={contactFormik.handleBlur}
                        error={
                          contactFormik.touched.contactEmail &&
                          contactFormik.errors.contactEmail
                        }
                        errorMessage={contactFormik.errors.contactEmail}
                        required={true}
                        labelStyle={{ marginBottom: "10px" }}
                      />
                      <PhoneNumberInput
                        value={contactFormik.values.contactPhoneNumber}
                        onChange={handleContactPhoneInputChange}
                        onBlur={() =>
                          contactFormik.setFieldTouched(
                            "contactPhoneNumber",
                            true,
                          )
                        }
                        error={contactFormik.errors.contactPhoneNumber}
                        touched={contactFormik.touched.contactPhoneNumber}
                        placeholder="e.g. (415) 555-0198"
                        label="Contact Person Contact No."
                        width="100%"
                        height="40px"
                        countryListWidth="300px"
                        phoneContainerStyle={{ marginBottom: "15px" }}
                        required={true}
                      />
                      <DynamicTextField
                        label="Contact Person Designation"
                        type="text"
                        name="contactDesignation"
                        placeholder="e.g. Technical Recruiter"
                        value={contactFormik.values.contactDesignation}
                        onChange={contactFormik.handleChange}
                        onBlur={contactFormik.handleBlur}
                        error={
                          contactFormik.touched.contactDesignation &&
                          contactFormik.errors.contactDesignation
                        }
                        errorMessage={contactFormik.errors.contactDesignation}
                        style={{ width: "100%" }}
                        labelStyle={{ marginBottom: "10px" }}
                        required={true}
                      />
                      <DynamicTextField
                        label="Contact Person Location"
                        type="text"
                        name="contactLocation"
                        placeholder="e.g. New York, USA"
                        value={contactFormik.values.contactLocation}
                        onChange={contactFormik.handleChange}
                        onBlur={contactFormik.handleBlur}
                        error={
                          contactFormik.touched.contactLocation &&
                          contactFormik.errors.contactLocation
                        }
                        errorMessage={contactFormik.errors.contactLocation}
                        style={{ width: "100%" }}
                        labelStyle={{ marginBottom: "10px" }}
                        required={true}
                      />
                    </>
                  )}
                </div>
              </ContentDialog>

              <ContentDialog
                isOpen={showDeleteContactPopup}
                onClose={() => {
                  setShowDeleteContactPopup(false);
                  setSelectedContact(null);
                }}
                onCloseIconClose={() => {
                  setShowDeleteContactPopup(false);
                  setSelectedContact(null);
                }}
                submitButtonLabel="Delete"
                cancelButtonLabel="Cancel"
                event={handleDeleteClientContactDetails}
                contentWidth="40vw"
                contentHeight={"auto"}
                title={"Delete Contact"}
              >
                <div style={{ padding: "25px", textAlign: "center" }}>
                  <p>Are you sure you want to delete this contact?</p>
                  <p>
                    <strong>{selectedContact?.name}</strong> -{" "}
                    {selectedContact?.email}
                  </p>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "14px",
                      marginTop: "10px",
                    }}
                  >
                    This action cannot be undone.
                  </p>
                </div>
              </ContentDialog>
              <div className="client-details-content-container">
                {renderContent()}
              </div>
            </div>
          )}
        </SidePopup>
        <ConfirmationPopup
          isOpen={isClientDeleteDialogOpen}
          onClose={() => setIsClientDeleteDialogOpen(false)}
          onConfirm={handleDeleteClient}
          title={`Delete ${tenantLabel}?`}
          subTitle="Confirmation required"
          message={
            <span>
              You are about to delete{" "}
              <span
                style={{
                  color: "#6665ea",
                  fontWeight: "bold",
                }}
              >
                "{applyEllipsis(selectedClient?.name, 35)}"
              </span>
              , This action will permanently remove this {tenantLabelLower}{" "}
              details, including associated jobs and related data.
              <br />
              <br />
              This action cannot be undone. Are you sure you want to delete?
            </span>
          }
          cancelLabel="No, Cancel"
          confirmLabel="Yes, Delete"
          confirmButtonClass="popup-button-danger"
        />
        {selectedJobDetails && (
          <JobsDetailsContainer
            isOpen={jobsSideContainerOpen}
            onClose={handleCloseJobDetailsContainer}
            selectedJob={selectedJobDetails}
            isEditingJob={isEditingJob}
            setIsEditingJob={setIsEditingJob}
            activeTab={jobDetailsActiveTab}
            setActiveTab={setJobDetailsActiveTab}
            formik={jobEditFormik}
            sideDialogformik={sideDialogformik}
            editedJobData={editedJobData}
            handleEditJob={handleEditJob}
            handleJobChange={handleJobChange}
            saveJobChanges={saveJobChanges}
            handleDeleteJob={handleOpenDeleteJobDialog}
            assignedCount={assignedCount}
            setAssignedCount={setAssignedCount}
            onAssignedCountChange={setAssignedCount}
            isFetchingRecommendedCandidates={isFetchingRecommendedCandidates}
            resetJobEdit={resetJobEdit}
            jobId={selectedJobDetails?.id}
          />
        )}
        <ConfirmationPopup
          isOpen={openJobDeleteDialog}
          onClose={() => setOpenJobDeleteDialog(false)}
          onConfirm={handleDeleteJob}
          title="Delete Job?"
          subTitle="Confirmation required"
          message={
            <span>
              This will delete{" "}
              <span
                style={{
                  color: "#6665ea",
                  fontWeight: "bold",
                }}
              >
                "{applyEllipsis(selectedJobDetails?.title, 35)}"
              </span>
              Are you sure you want to delete this job? This action cannot be
              undone.
            </span>
          }
          cancelLabel="No, Cancel"
          confirmLabel="Yes, Delete"
          confirmButtonClass="popup-button-danger"
        />
      </div>
      {isImportOpen && <ClientImportXL showHeader={false} />}
    </div>
  );
}

export default CreateClient;
